import { useEffect, useState } from 'react';

import { AUTH_PATHS } from '@/lib/constants/paths';

export const useUrlWithQueryString = (pathname: string = AUTH_PATHS.로그인, additionalParams?: Record<string, string>, isRemoveOrigin = true) => {
  const [returnUrl, setReturnUrl] = useState('');

  useEffect(() => {
    const targetUrl = getUrlWithQueryString(pathname, additionalParams, isRemoveOrigin);
    setReturnUrl(targetUrl);
  }, [additionalParams, isRemoveOrigin, pathname]);

  return returnUrl;
};

export const getUrlWithQueryString = (pathname: string = AUTH_PATHS.로그인, additionalParams?: Record<string, string>, isRemoveOrigin = true) => {
  const targetUrl = new URL(pathname, window.location.origin);
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.forEach((v, k) => {
    targetUrl.searchParams.append(k, v as string);
  });

  if (additionalParams) {
    Object.entries(additionalParams).forEach(([key, value]) => {
      targetUrl.searchParams.append(key, value);
    });
  }

  return isRemoveOrigin ? targetUrl.toString().replace(window.location.origin, '') : targetUrl.toString();
};
